import * as types from './types';

export default {
  [types.SET_MIPIH](state, isMIPIH) {
    state.isMIPIH = isMIPIH;
  },

  [types.SET_FRANCE_CONNECT_DATA](state, data) {
    state.franceConnectData = data;
  },

  [types.CLEAR_FRANCE_CONNECT_DATA](state) {
    state.franceConnectData = null;
  },

  [types.SET_EDPV3_USER_MESSAGE](state, data) {
    state.edpv3UserMessage = data.edpv3UserMessage;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/authentification/mutations.js